import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import ArrayUtils from '../../../../../modules/ArrayUtils';
import ObjectUtils from '../../../../../modules/ObjectUtils';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';

function STLPropertyDetailedBill(props) {
  const { bill, } = props;

  const billItems = VerticalLabelList.toList({
    'External Account Id': bill.externalAccountId,
    'Tax Year': bill.taxYear,
    'Due Date': bill.dueDate,
    Paid: bill.isPaid,
    'Paid Date': bill.paidDate,
    'Bill Amount': bill.billAmount_value,
    'Bill Balance': bill.billBalance_value,
    'St. Louis Bill Balance': bill.stlBillBalance_value,
    'Calculated St. Louis Bill Balance': bill.calculatedStlBillBalance_value,
    'PayIt Balance': bill.payItBalance_value,
    Interest: bill.interest_value,
    'Tax Rate': bill.taxRate,
    'Bill Suffix': bill.billSuffix,
    Version: bill.version,
    'Suit Id': bill.suitId,
    'VLT Exempt': bill.vltExempt,
    'Rec Fee': bill.recFee_value,
    'Total Assessment': bill.totalAssessment_value,
    'Court Cost Balance': bill.courtCostBalance_value,
    'Court Cost Amount': bill.courtCostAmount_value,
    'Attorney Fee Balance': bill.attorneyFeeBalance_value,
    'Attorney Fee Amount': bill.attorneyFeeAmount_value,
    'Court Cost Fee': bill.courtCostFee_value,
    Penalty: bill.penalty_value,
    Cancelled: bill.canceled,
    'New Notification Enabled': bill.newNotificationEnabled,
    'Due Soon Notification Enabled': bill.dueSoonNotificationEnabled,
    'Overdue Notification Enabled': bill.overdueNotificationEnabled,
    'Last Day To Pay Notification Enabled': bill.lastDayToPayNotificationEnabled,
    'Account Id': bill.accountId,
    Id: bill.id,
  });

  const options = {};
  const paymentTransactions = ObjectUtils.formatStringAsJSONArray(bill.paymentTransactions);
  const flatPmtTxns = ArrayUtils.selectivelyFlattenJSONArrayObjects(paymentTransactions);

  options.headerFormatter = object => _.startCase(object.header);

  const paymentTransactionModel = Grid.toModelFromList(flatPmtTxns, options);

  return (
    <div style={{ height: '100%', fontSize: '20px', }}>
      <FieldSet title="Bill Summary">
        <VerticalLabelList items={billItems} />
      </FieldSet>
      <div style={{ paddingTop: '10px', }}>
        <FieldSet title="Payment Transactions">
          <Grid
            headers={paymentTransactionModel.headers}
            rows={paymentTransactionModel.format(paymentTransactions)}
            onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
          />
        </FieldSet>
      </div>
    </div>
  );
}

STLPropertyDetailedBill.propTypes = {
  bill: PropTypes.instanceOf(Object).isRequired,
};

export default STLPropertyDetailedBill;
